import { SREV2 } from '../../../api/pushGenie';
import { getAclViewClassName } from '../../../restrictions/utils';
import { getDoc, getSelectedClinicId } from '../../../store/idbHandler';
import DoctorSelectorPopup from '../../common/DoctorSelectorPopOver';

const CreateVisitBt: React.FC<{
    onClick: (docid: string) => void;
    ptVisitId?: string;
}> = ({ onClick, ptVisitId }) => {
    return (
        <DoctorSelectorPopup
            onSelect={(myDoc) => onClick(myDoc?.id || getDoc()?._id || '')}
            className={getAclViewClassName(SREV2.PT_DETAILS_VISIT_ACTIONS)}
            clinicId={getSelectedClinicId()}
        >
            <div className="w-full p-16">
                <button className="primary-btn px-12 py-8 btn--small w-full">
                    <span className="w-full text-center">
                        {ptVisitId ? 'Start Visit' : 'Create new visit'}
                    </span>
                </button>
            </div>
        </DoctorSelectorPopup>
    );
};

export default CreateVisitBt;
